module.exports = __webpack_public_path__ + "static/media/figma-1.80505242.svg";